var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-card',{attrs:{"title":_vm.$t('dashboard.currentVisitors')}},[_c('line-map',{staticClass:"dashboard-map",attrs:{"map-data":_vm.lineMapData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }